import { GenericAbortSignal } from 'axios'
import { API_REIMBURSEMENT_URL } from '../constants/base-urls'
import type { IPaginationParam, IPaginationResponse, IReimbursement, IReimbursementStatistic } from '../types'
import { createAxiosInstance } from '../utils'

const axios = createAxiosInstance({
  baseURL: API_REIMBURSEMENT_URL,
  withAuth: true,
})

type FetchReimbursementParams = {
  endDate?: string
  startDate?: string
  status?: string
} & IPaginationParam

export const fetchStatistic = (params?: FetchReimbursementParams) => {
  return axios.get<{ data: IReimbursementStatistic[] }>(`/reimbursement/count`, { params }).then(({ data }) => data.data)
}

export const fetchReimbursement = (params?: FetchReimbursementParams, signal?: GenericAbortSignal) => {
  return axios.get<{ data: IPaginationResponse<IReimbursement> }>(`/reimbursement`, { params, signal }).then(({ data }) => data.data)
}

export const updateStatusReimbursement = (payload: Record<string, any>) => {
  return axios.patch(`/reimbursement`, payload).then((response) => response.data.data)
}
